import { useState, useEffect } from 'react';
import pricingService from '../services/pricingService';
import { safeData } from '../utils/arrayUtils';

export const usePricing = () => {
  const [pricing, setPricing] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPricing = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = safeData(await pricingService.getFormattedForLanding());
      setPricing(data);
    } catch (err) {
      console.error('Error fetching pricing:', err);
      setError(err.message);
      setPricing({ plans: [] });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPricing();
  }, []);

  const refresh = () => {
    pricingService.clearCache();
    fetchPricing();
  };

  return {
    pricing,
    isLoading,
    error,
    refresh
  };
};

export default usePricing;
